import React, { Component } from 'react';
import i18n from 'i18n-react';
import PropTypes from 'prop-types';
import Breadcrumbs from 'react-router-dynamic-breadcrumbs';

import { ActionCard } from 'C4';

const { Raven } = window;

const crumbRoutes = {
  '/main': 'Home',
  '/main/:id': '\':id\' (404)',
};

export default class NotFoundView extends Component {
  constructor(props) {
    super(props);

    this.state = { Sentry: Raven };
  }

  componentDidMount() {
    window.location.replace('/main');

    const { Sentry } = this.state;
    if (Sentry !== undefined && Sentry !== null) {
      // Raven.captureException('404 - Not Found', { extra: window.location });
    }
  }

  render() {
    const { children } = this.props;
    return (
      <div className="contentContainer">
        <Breadcrumbs
          mappedRoutes={crumbRoutes}
          WrapperComponent={() => <ul className="breadcrumb__List">{children}</ul>}
          LinkComponent={() => <li className="breadcrumb__item">{children}<span className="breadcrumb__separator">&#62;</span></li>}
          ActiveLinkComponent={() => <li className="breadcrumb__item--active">{children}</li>}
        />
        <ActionCard
          superTitle={i18n.translate('general.oops')}
          title={i18n.translate('general.pageNotFound')}
          buttonText={i18n.translate('nav.home')}
          buttonLink="/main"
          buttonIcon="fa-home"
        />
      </div>
    );
  }
}

NotFoundView.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
};

NotFoundView.defaultProps = {
  children: [],
};
